const RiskRewardLoadingSkeleton = () => {
  return (
    <div
      data-cy-id="reward-loading-skeleton"
      className="flex flex-col gap-x1_25"
    >
      <div className="flex items-center gap-x0_75">
        <div className="bones size-x2 rounded-full"></div>
        <div className="bones h-x1_25 w-60 rounded-full "></div>
      </div>
      <div className="flex items-center gap-x0_75">
        <div className="bones size-x2 rounded-full"></div>
        <div className="bones h-x1_25 w-60 rounded-full"></div>
      </div>
      <div className="flex items-center gap-x0_75">
        <div className="bones size-x2 rounded-full"></div>
        <div className="bones h-x1_25 w-60 rounded-full"></div>
      </div>
    </div>
  );
};

export default RiskRewardLoadingSkeleton;
